"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CODE_EVAL_SOURCE_MAX_BYTES = void 0;
exports.CODE_EVAL_SOURCE_MAX_BYTES = 256 * 1024;
